import { vaultPostRequest } from '../helpers';
import type { IQueueUploadRequest } from './queue-upload-request';
import type { IQueueUploadResponse } from './queue-upload-response';
import { queueUploadResponseSchema } from './queue-upload-response';

export async function queueUploadApi(body: IQueueUploadRequest): Promise<IQueueUploadResponse> {
  return vaultPostRequest({ path: '/upload/queue', body, schema: queueUploadResponseSchema });
}
